import ManageAudit from "@pages/ManageAudit";
import ManageAuditCheckpoint from "@pages/ManageAudit/AuditCheckpoint";
import ManageAuditGroup from "@pages/ManageAudit/AuditGroup";
import ManageAuditLocations from "@pages/ManageAudit/AuditLocation";
import ManageAuditVendor from "@pages/ManageAudit/AuditVendor";
import AuditStatus from "@pages/ManageAudit/AuditStatus/AuditStatus";
import AuditTaskList from "@pages/ManageAudit/AuditStatus/AuditTaskList";
import MISReports from "@pages/ManageAudit/AuditStatus/MisReports/MISReport";
import MISTaskList from "@pages/ManageAudit/AuditStatus/MisReports/MISTaskList";
import MISTaskHistoryList from "@pages/ManageAudit/AuditStatus/MisReports/MISTaskHistoryList";

export const ManageAuditRoutes = [
  {
    path: "/audit/audit-status",
    name: "audit_audit_status",
    component: AuditStatus,
  },
  {
    path: "/audit/mis-reports",
    name: "audit_mis_reports",
    component: MISReports,
  },
  {
    path: "/audit/manage-audit",
    name: "audit_manage_audit",
    component: ManageAudit,
  },
  {
    path: "/audit/manage-audit/group",
    name: "audit_manage_audit",
    component: ManageAuditGroup,
  },
  {
    path: "/audit/manage-audit/location",
    name: "audit_manage_audit",
    component: ManageAuditLocations,
  },
  {
    path: "/audit/manage-audit/vendor",
    name: "audit_manage_audit",
    component: ManageAuditVendor,
  },
  {
    path: "/audit/manage-audit/checkpoint",
    name: "audit_manage_audit",
    component: ManageAuditCheckpoint,
  },
  {
    path: "/audit/audit-status/task/list/:id",
    name: "audit_audit_status",
    component: AuditTaskList,
  },
  {
    path: "/audit/mis-reports/task/list",
    name: "audit_mis_reports",
    component: MISTaskList,
  },
  {
    path: "/audit/mis-reports/task/history/list",
    name: "audit_mis_reports",
    component: MISTaskHistoryList,
  },
];
